import React, { useState, useRef, useEffect } from 'react';
import Send from '@mui/icons-material/Send';

export default function ChatInput({ inputType, placeholder, onSubmit, error, options }) {
    const [value, setValue] = useState('');
    const inputRef = useRef(null);

    useEffect(() => {
        if (inputRef.current) {
            inputRef.current.focus();
        }
    }, [inputType]);

    const handleSubmit = () => {
        if (!value.trim()) return;
        onSubmit(value.trim());
        setValue('');
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            handleSubmit();
        }
    };

    if (inputType === 'none') return null;

    if (inputType === 'buttons' && options) {
        return (
            <div className="oc-input-area">
                {error && <p className="oc-input-error">{error}</p>}
                <div className="oc-btn-group">
                    {options.map((opt) => (
                        <button
                            key={opt.value}
                            className={`oc-btn ${opt.variant === 'primary' ? 'oc-btn-primary' : 'oc-btn-outline'}`}
                            onClick={() => onSubmit(opt.value)}
                        >
                            {opt.label}
                        </button>
                    ))}
                </div>
            </div>
        );
    }

    if (inputType === 'confirm') {
        return (
            <div className="oc-input-area">
                <div className="oc-btn-group">
                    <button className="oc-btn oc-btn-primary" onClick={() => onSubmit('confirm')}>
                        {placeholder || 'Continue'}
                    </button>
                </div>
            </div>
        );
    }

    // Text / email / password / tel input
    return (
        <div className="oc-input-area">
            {error && <p className="oc-input-error">{error}</p>}
            <div className="oc-input-row">
                <input
                    ref={inputRef}
                    className="oc-text-input"
                    type={inputType || 'text'}
                    placeholder={placeholder}
                    value={value}
                    onChange={(e) => setValue(e.target.value)}
                    onKeyDown={handleKeyDown}
                    autoComplete={inputType === 'password' ? 'new-password' : 'off'}
                />
                <button
                    className="oc-send-btn"
                    onClick={handleSubmit}
                    disabled={!value.trim()}
                    aria-label="Send"
                >
                    <Send sx={{ fontSize: 20 }} />
                </button>
            </div>
        </div>
    );
}
